import { ChangeEvent } from 'react';
import useSearchField from './useSearchField';

/** wrapper for `useState()`. initialises the value from the URL search parameters or other default params. */
export default function useSearchFieldAndInput(name: string, params?: {}): [string | undefined, (event: ChangeEvent<HTMLInputElement> | {target: {value: string}}) => string] {
    const [state, setState] = useSearchField(name, params);

    return [state, (event: ChangeEvent<HTMLInputElement> | {target: {value: string}}) => {
        // console.debug(name, 'set to', event.target.value);
        setState(event.target.value);
        return event.target.value;
    }];
}
